/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
import React from 'react';
import { compose } from 'recompose';
import Block from '../block/Block';
import Button from '../button/Button';
import ResponsiveModalCloseIcon from '../icons/responsive-modal-close-icon/ResponsiveModalCloseIcon';
import ModalPrintButton from './ModalPrintButton';
import withStrings from '../with-strings/with-strings';
import closeChildWindow from '../child-window/close-child-window/close-child-window';
import styles from './ResponsiveModalHeaderButtons.less';

var ResponsiveModalHeaderButtons = function ResponsiveModalHeaderButtons(_ref) {
  var showCloseButton = _ref.showCloseButton,
      showPrintButton = _ref.showPrintButton,
      getString = _ref.getString;
  return /*#__PURE__*/React.createElement(Block, {
    layout: true,
    horizontal: true,
    reverse: true,
    justifyEnd: true,
    center: true,
    className: styles.buttons
  }, showCloseButton && /*#__PURE__*/React.createElement(Button, {
    onClick: closeChildWindow,
    className: styles.closeButton,
    "aria-label": getString('global.close')
  }, /*#__PURE__*/React.createElement(Block, {
    layout: true,
    vertical: true,
    centered: true
  }, /*#__PURE__*/React.createElement(ResponsiveModalCloseIcon, null))), showPrintButton && /*#__PURE__*/React.createElement(ModalPrintButton, null));
};

export default compose(withStrings)(ResponsiveModalHeaderButtons);